import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'EcommOptionsList',
})(({ spacing, type }) => ({
  options: {
    marginTop: spacing(0),
    gap: spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },
  selectableCardContent: {
    ...type['18_regular'],
  },
}));

export default useStyles;
